export default __webpack_public_path__ + "static/media/quote.924d4fef.svg";